import { EventTypes, Locations, PageSource, track } from '@mc/track-event'

export const actions = {
  PAUSE_CAROUSEL_ANIMATION: 'pause-carousel-animation',
  RESUME_CAROUSEL_ANIMATION: 'resume-carousel-animation',
  CLICK_CAROUSEL_HERO: 'click-carousel-hero',
}

type actionsType =
  | typeof actions.PAUSE_CAROUSEL_ANIMATION
  | typeof actions.RESUME_CAROUSEL_ANIMATION
  | typeof actions.CLICK_CAROUSEL_HERO

export const trackPlayPauseClick = (action: actionsType) =>
  track(EventTypes.HOMEPAGE_CLICK, {
    location: Locations.HERO,
    page_source: PageSource.HOMEPAGE,
    action,
  })

export const trackClickCarouselHero = (action: actionsType) =>
  track(EventTypes.HOMEPAGE_CLICK, {
    location: Locations.HERO,
    page_source: PageSource.HOMEPAGE,
    action,
  })
